/* istanbul ignore file */
import { Unsubscribe } from '@reduxjs/toolkit';

import { CustomStore } from '@/redux/create-store';

import * as adminEpics from './admin.epics';
import * as authEpics from './auth.epics';
import * as boxEpics from './box.epics';
import * as cartEpics from './cart.epics';
import * as categEpics from './categ.epics';
import * as checkoutEpics from './checkout.epics';
import * as contactEpics from './contact.epics';
import * as customizationEpics from './customization.epics';
import * as exproEpics from './expro.epics';
import * as formEpics from './form.epics';
import * as guiEpics from './gui.epics';
import * as notebookEpics from './notebook.epics';
import * as primeurEpics from './primeur.epics';
import * as productEpics from './product.epics';
import * as storageEpics from './storage.epics';
import * as userEpics from './user.epics';
import * as wishListEpics from './wishList.epics';

export const addListeners = (store: CustomStore): Unsubscribe[] => {
  const { startAppListening } = store;

  const listeners = [
    ...Object.values(adminEpics),
    ...Object.values(authEpics),
    ...Object.values(boxEpics),
    ...Object.values(cartEpics),
    ...Object.values(categEpics),
    ...Object.values(checkoutEpics),
    ...Object.values(contactEpics),
    ...Object.values(customizationEpics),
    ...Object.values(exproEpics),
    ...Object.values(formEpics),
    ...Object.values(guiEpics),
    ...Object.values(notebookEpics),
    ...Object.values(primeurEpics),
    ...Object.values(productEpics),
    ...Object.values(storageEpics),
    ...Object.values(userEpics),
    ...Object.values(wishListEpics)
  ];

  return listeners.map((item) => startAppListening(item as any));
};
